import { EXTERNAL_API_SHOW_COLLECTION_MAPPING } from './constants';

export function showCollectionMapping() {
  return {
    type: EXTERNAL_API_SHOW_COLLECTION_MAPPING,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_SHOW_COLLECTION_MAPPING:
      return {
        ...state,
        enableCollectionMapping: !state.enableCollectionMapping,
      };

    default:
      return state;
  }
}
